export const isPhoneNumberRequired = (currency?: string): boolean => {
  return currency === 'MYR' || currency === 'IDR';
};
